declare module '*.png' {
  const url: string
  export default url
}

declare module '*.jpg' {
  const url: string
  export default url
}

declare module '*.webp' {
  const url: string
  export default url
}

declare module 'bundle-text:*' {
  const contents: string
  export default contents
}

declare module '*.less' {
  const lessModule: Record<string, string>
  export default lessModule
}

declare module 'url:*' {
  const path: string
  export default path
}

interface URLSearchParams {
  readonly size: number
}
